import React from "react";
import LModal from "../../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../../common/components/Modals/ModalHeader/ModalHeader";

interface IPartnersLifeMultiBenefitDiscountModalProps {
    isOpen: boolean;
    onClose: () => void;
}

/**
 *  This is based on the content from https://www.lifedirect.co.nz/article/partnerslife
 */

const PartnersLifeMultiBenefitDiscountModal: React.FC<IPartnersLifeMultiBenefitDiscountModalProps> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <LModal
            Header={() => (
                <ModalHeader
                    onClose={onClose}
                    title="Partners Life Multi-benefit discount"
                />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => (
                <React.Fragment>
                    <h3>Multi-Benefit Discount</h3>
                    <p>
                        Partners Life’s Private Medical Cover is discounted by 15% (which
                        is known as a “bundled discount”) so long as there is risk cover
                        (like Life Cover or Trauma Cover) on the same policy.
                    </p>
                    <p>
                        Note that the risk cover premium must total at least $7.05 per
                        month to qualify for the bundled discount.
                    </p>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default PartnersLifeMultiBenefitDiscountModal;
